import {
  CLEAR_SOCKET_BUFFER,
  NOTIFY_GENERIC_PROGRESS_ALERT,
  PROCESS_SOCKET_MESSAGE,
  QUEUE_SOCKET_MESSAGE,
} from "constants/actionTypes";

import { GenericAlertMessage } from "./types";

export function queueSocketMessage(message_type, payload) {
  return {
    type: QUEUE_SOCKET_MESSAGE,
    message_type,
    payload,
  };
}

export function clearSocketBuffer() {
  return {
    type: CLEAR_SOCKET_BUFFER,
  };
}

export function processSocketMessage(message) {
  return {
    type: PROCESS_SOCKET_MESSAGE,
    message,
  };
}

export const displayGenericToast = (message: GenericAlertMessage) => {
  const { object } = message;
  return {
    type: NOTIFY_GENERIC_PROGRESS_ALERT,
    payload: object,
  };
};
